import { render, staticRenderFns } from "./result-page.vue?vue&type=template&id=26e9d81c&scoped=true&"
import script from "./result-page.vue?vue&type=script&lang=ts&"
export * from "./result-page.vue?vue&type=script&lang=ts&"
import style0 from "./result-page.vue?vue&type=style&index=0&id=26e9d81c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e9d81c",
  null
  
)

export default component.exports